module.exports = __webpack_public_path__ + "static/media/who-2.0b887efd.jpg";